import {useMemo} from 'react';

import type {IntervalValue, PerformanceData, StatCardData} from '../../types';
import IntervalSelector from '../common/IntervalSelector/IntervalSelector';
import StatCard from './components/StatCard/StatCard';

type PerformanceSectionProps = {
  data: PerformanceData;
  interval: IntervalValue;
  onIntervalChange: (value: IntervalValue) => void;
};

const PerformanceSection: React.FC<PerformanceSectionProps> = ({
  data,
  interval,
  onIntervalChange
}) => {
  const metrics = useMemo<Record<string, StatCardData>>(
    () => ({
      customerReview: {
        value: data.customer_review?.value,
        changePercentage: data.customer_review?.change_percentage,
        title: 'نظر مشتریان',
        subtitle: 'نظر منفی',
        key: 'customer_review',
        trend: data.customer_review?.trend
      },
      customerRate: {
        value: data.customer_rate?.value,
        changePercentage: data.customer_rate?.change_percentage,
        title: 'امتیاز مشتریان',
        subtitle: '',
        key: 'customer_rate',
        trend: data.customer_rate?.trend
      },
      bikerWait: {
        value: data.biker_wait?.value,
        changePercentage: data.biker_wait?.change_percentage,
        title: 'انتظار پیک',
        subtitle: 'گزارش تأخیر',
        key: 'biker_wait',
        trend: data.biker_wait?.trend
      },
      nfc: {
        value: data.nfc?.value,
        changePercentage: data.nfc?.change_percentage,
        title: 'نیازمند تماس',
        subtitle: 'سفارش',
        key: 'nfc',
        trend: data.nfc?.trend
      }
    }),
    [data]
  );

  return (
    <section className="flex flex-col gap-4 px-4 py-4">
      <h2 className="text-subtitle-md text-gray-09">عملکرد شما</h2>
      <IntervalSelector value={interval} onChange={onIntervalChange} />

      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-3">
          <h3 className="text-body-md-emphasis text-gray-09">رضایت مشتریان</h3>
          <div className="flex gap-2.5">
            <StatCard data={metrics.customerReview} />
            <StatCard data={metrics.customerRate} />
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h3 className="text-body-md-emphasis text-gray-09">مدیریت سفارش‌ها</h3>
          <div className="flex gap-2.5">
            <StatCard data={metrics.bikerWait} />
            <StatCard data={metrics.nfc} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PerformanceSection;
